import { ApolloProvider } from '@apollo/react-hooks';
import { LightTheme, LuiBackground } from '@jda/lui-common-component-library';
import { Box, CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import { InMemoryCache } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { RestLink } from 'apollo-link-rest';
import { TokenRefreshLink } from 'apollo-link-token-refresh';
import React, { Dispatch } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import './App.css';
import AppPage from './containers/App';
import { useRefreshToken } from './containers/Login/AuthToken';
import client from './utils/eventEmit';
import { SnackbarProvider } from 'notistack';
import jwt_decode from 'jwt-decode';
declare global {
  interface Window {
    REACT_API_URL: any;
    REACT_APIM_URL: any;
    REACT_LOGOUT_URL: any;
    REACT_REFRESH_TOKEN_URL: any;
  }
}

// type AppProps = {
//   link?: string;
// };

export const StateContext = React.createContext<any>({});
export const DispatchContext = React.createContext<Dispatch<any>>(() => {});

export const App = () => {
  //  const [theme, setTheme] = React.useState(LightTheme);

  // const toggleTheme = () => setTheme(theme => (theme === LightTheme ? DarkTheme : LightTheme));

  const cache = new InMemoryCache({ addTypename: true });
  const authToken = localStorage.getItem(window.REACT_ACCESS_TOKEN_URL);
  // const [refreshToken, setRefreshToken] = useRefreshToken();
  const refreshToken = localStorage.getItem(window.REACT_REFRESH_TOKEN_URL);

  const history = useHistory();

  const restLink = new RestLink({
    endpoints: { v1: window.REACT_API_URL, v2: window.REACT_APIM_URL },
    uri: window.REACT_API_URL
  });
  const searchParam = history?.location?.search ? `${history?.location?.pathname}${history?.location?.search}` : '';

  const authMiddleware = (authToken: any) => {
    let accessToken = authToken;
    if (accessToken?.exp * 1000 <= Date.now()) {
      accessToken = '';
    }
    return new ApolloLink((operation, forward) => {
      // add the authorization to the headers
      if (accessToken) {
        operation.setContext({
          headers: {
            authorization: `Bearer ${accessToken}`
          }
        });
      }
      return forward(operation);
    });
  };

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
      graphQLErrors.map(({ message, locations, path }) =>
        console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      );
    if (networkError) {
      const test: any = networkError;
      if (test['statusCode'] === 401) {
        window.location.href = window.REACT_LOGOUT_URL;
      }
      if (test['statusCode'] === 403) {
        client.emit('networkError', networkError);
      }
      console.log(`[Network error]: ${networkError}`);
    }
  });

  const tokenRefreshLink: any = new TokenRefreshLink<{ token: string; newRefreshToken: string }>({
    isTokenValidOrUndefined: () => !isTokenExpired() || typeof authToken !== 'string',
    fetchAccessToken: async () => {
      return await fetch(`${window.REACT_REFRESH_TOKEN_URL}&refresh_token=${refreshToken}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: JSON.stringify({ title: 'Self Service Authorization' })
      })
        .then(response => response.json())
        .then(data => data);
    },
    handleFetch: newTokens => {},
    handleResponse: (operation, accessTokenField) => (response: any) => {
      // setAuthToken(response?.access_token);
      localStorage.setItem(window.REACT_ACCESS_TOKEN_URL, response?.access_token);
      localStorage.setItem(window.REACT_REFRESH_TOKEN_URL, response?.refresh_token);
    },
    handleError: err => {
      // full control over handling token fetch Error
      console.warn('Your refresh token is invalid. Try to relogin');
      console.error(err);
    }
  });

  const isTokenExpired = () => {
    let authDecode = { exp: 0 };
    const authToken = localStorage.getItem(window.REACT_ACCESS_TOKEN_URL) || '';
    authDecode = jwt_decode(authToken);
    const timeDiff = authDecode.exp * 1000 - Date.now();
    if (Math.floor(timeDiff / 60000) < 30 && Date.now() <= authDecode.exp * 1000) {
      return true;
    } else {
      return false;
    }
  };

  const initClient = () =>
    new ApolloClient({
      link: ApolloLink.from([authMiddleware(authToken), errorLink, restLink]),
      cache: cache
    });

  const data = {
    todos: [],
    visibilityFilter: 'SHOW_ALL',
    networkStatus: {
      __typename: 'NetworkStatus',
      isConnected: false
    }
  };

  cache.writeData({ data });

  return (
    <ThemeProvider theme={LightTheme}>
      <ApolloProvider client={initClient()}>
        <SnackbarProvider
          maxSnack={3}
          data-id="snack-bar"
          // action={key => (
          //   <IconButton color="inherit" aria-label="Close Icon Button"  id="close-button">
          //     <CloseIcon fontSize="small" />
          //   </IconButton>
          // )}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          <>
            <CssBaseline />
            <LuiBackground>
              <Box display="flex" width="100%">
                <Switch>
                  {authToken && <Route path="/" component={AppPage} />}
                  <Redirect
                    to={{
                      pathname: '/login',
                      state: { search: searchParam }
                    }}
                  />
                </Switch>
              </Box>
            </LuiBackground>
          </>
        </SnackbarProvider>
      </ApolloProvider>
    </ThemeProvider>
  );
};

export default App;
